import Link from 'next/link';

import Img from './Image';

type BrandLogoProps = {
  dimension?: { width: number; height: number };
  src?: string;
  href?: string;
  className?: string;
};

const BrandLogo = ({ src, href, className }: BrandLogoProps) => {
  return (
    <div className={`brand-logo-container p-7 px-2 py-0 md:p-0 ${className || ''}`.trim()}>
      <Link href={href || '/'} className="brand-logo">
        <div className="relative md:w-30 md:h-25 w-25 h-15">{src && <Img src={src} alt="Brand Logo" className="object-contain" fill sizes="140px" priority />}</div>
      </Link>
    </div>
  );
};

export default BrandLogo;
